import React from "react";

import { displayError } from "../../../helpers";
import { CheckboxWithLabel, SwitchWithLabel, Textfield } from "../../../components";
import { useSelector } from "react-redux";

export default function CorporateMatch({ handleChange, validationErrors }) {
    const state = useSelector(state => state.donationCheckout);

    const assignClasses = state.doubleTheImpact ? "cm-box-outer yellow" : "cm-box-outer"

    return <div className={assignClasses} id="corporateMatchSection">
        <div className="cm-box-inner">
            <CheckboxWithLabel checkboxStyles={{ color: 'neutral.dark' }} label="Double the impact of your gift" nameAndId="doubleTheImpact" handleCheck={handleChange} />
            {state.doubleTheImpact &&
                <div id="corporate_match_div">
                    <div className='row'>
                        <div className="col">
                            <div className="checkoutforms-group">
                                <Textfield
                                    id="corporateMatchEmployer"
                                    name="corporateMatchEmployer"
                                    label="Employer's Name *"
                                    variant="filled"
                                    value={state.corporateMatchEmployer}
                                    error={displayError(validationErrors?.corporateMatch)}
                                    helperText={validationErrors?.corporateMatch}
                                    onChange={handleChange}
                                    sx={{
                                        '& .MuiFilledInput-root, .Mui-focused': {
                                            backgroundColor: 'white !important',

                                            ":after": {
                                                borderBottom: 'none'
                                            }
                                        },
                                        '& #corporateMatchEmployer-helper-text': {
                                            backgroundColor: 'transparent !important'
                                        },
                                    }}
                                    fullWidth
                                />
                            </div>
                        </div>
                    </div>
                    <SwitchWithLabel label="Contact me for corporate matching" nameAndId="contactMeForCorporateMatch" onChange={handleChange} checked={state.contactMeForCorporateMatch} />
                </div>}
        </div>
    </div>
}